import { render } from "./FeatureLayout.vue?vue&type=template&id=79bcb895&scoped=true&ts=true"
import script from "./FeatureLayout.vue?vue&type=script&lang=ts"
export * from "./FeatureLayout.vue?vue&type=script&lang=ts"

import "./FeatureLayout.vue?vue&type=style&index=0&id=79bcb895&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bcb895"]])

export default __exports__